import Modal from '@components/Modal';
import React from 'react';
import commonStyles from '@modals/ModalsCommon.module.scss';
import { FixedSizeList as List } from 'react-window';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { IBM_Plex_Mono as ibmPlexMono } from 'next/font/google';
import CopyButton from '@/components/CopyButton';

import s from './JsonModal.module.scss';

const mono = ibmPlexMono({
  subsets: ['latin'],
  weight: '400',
});

const JsonModal = ({ json, onClose }: { json: Record<string, unknown>; onClose: () => void }): React.ReactElement => {
  const jsonData = JSON.stringify(json, null, 2);
  const jsonLines = jsonData.split('\n');

  const Row = ({ index, style }: { index: number; style: React.CSSProperties }): JSX.Element => (
    <div style={style}>
      <SyntaxHighlighter
        language="json"
        customStyle={{
          backgroundColor: 'var(--color-gray-0)',
          fontSize: 12,
          lineHeight: 0,
          margin: 0,
          overflow: 'hidden',
          padding: '8px 16px',
          width: '100%',
        }}
        codeTagProps={{ style: mono.style }}
      >
        {jsonLines ? jsonLines[index] : ''}
      </SyntaxHighlighter>
    </div>
  );

  return (
    <Modal isWide hideBottomInset title={'JSON'} onClose={onClose}>
      <div className={commonStyles.container}>
        <div className={s.jsonContent}>
          <CopyButton text={jsonData}>
            Copy
          </CopyButton>
          <List
            height={640}
            itemCount={jsonLines.length}
            itemSize={16}
            width="100%"
          >
            {Row}
          </List>
        </div>
      </div>
    </Modal>
  );
};

export default JsonModal;
